var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "margin-bottom-10" },
      [_vm._t("headline-category"), _vm._v(" "), _vm._t("form-category")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "margin-bottom-10" }, [
      _c("div", {
        ref: "subCategoryFormElement",
        domProps: { innerHTML: _vm._s(_vm.subCategoryForm) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }